import { useState } from 'react';
import { login, setCurrentUser } from '../utils/auth';
import { TEAM } from '../utils/constants';

export function LoginScreen({ onLogin }) {
  const [pw, setPw] = useState('');
  const [error, setError] = useState(false);

  const submit = () => {
    if (login(pw)) { onLogin(); }
    else { setError(true); }
  };

  return (
    <div style={wrap}>
      <div style={box}>
        <div style={{ fontSize: 28, textAlign: 'center', marginBottom: 8 }}>🔥</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9', textAlign: 'center' }}>SNP Engineering</div>
        <div style={{ fontSize: 13, color: '#64748b', textAlign: 'center', marginTop: 4, marginBottom: 24, letterSpacing: 1, textTransform: 'uppercase' }}>Task Tracker</div>
        {error && <div style={errBox}>Incorrect password</div>}
        <input
          type="password"
          placeholder="Enter password"
          value={pw}
          onChange={e => { setPw(e.target.value); setError(false); }}
          onKeyDown={e => e.key === 'Enter' && submit()}
          style={input}
          autoFocus
        />
        <button onClick={submit} style={btn}>Sign In</button>
      </div>
    </div>
  );
}

export function UserPickerScreen({ onPick }) {
  return (
    <div style={wrap}>
      <div style={box}>
        <div style={{ fontSize: 28, textAlign: 'center', marginBottom: 8 }}>👋</div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#f1f5f9', textAlign: 'center' }}>Who are you?</div>
        <div style={{ fontSize: 13, color: '#64748b', textAlign: 'center', marginTop: 4, marginBottom: 24 }}>Pick your name to continue</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {TEAM.map(name => (
            <button key={name} onClick={() => { setCurrentUser(name); onPick(name); }} style={{ ...btn, background: '#1e3a5f' }}>
              {name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

const wrap = { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0f172a', padding: 24 };
const box = { background: '#1e293b', borderRadius: 16, padding: 32, width: '100%', maxWidth: 360, boxShadow: '0 20px 60px rgba(0,0,0,.5)' };
const errBox = { background: '#fef2f2', color: '#dc2626', fontSize: 13, padding: '10px 12px', borderRadius: 8, marginBottom: 16, textAlign: 'center' };
const input = { background: '#0f172a', border: '1px solid #334155', borderRadius: 8, padding: 12, fontSize: 15, color: '#f1f5f9', width: '100%', outline: 'none', marginBottom: 12, fontFamily: 'inherit', boxSizing: 'border-box' };
const btn = { background: '#3b82f6', border: 'none', color: '#fff', borderRadius: 8, padding: 12, fontSize: 15, fontWeight: 600, width: '100%', cursor: 'pointer', fontFamily: 'inherit' };
